(function(angular) {
    'use strict';

    angular.module('aprima-config').provider('configuration', [
        configurationProvider,
    ]);

    function configurationProvider() {
        return {
            $get: [
                'ConfigurationRepository',
                configurationFactory,
            ],
        };
    }

    function configurationFactory(ConfigurationRepository) {
        return ConfigurationRepository;
    }
})(angular);
